module.exports = __webpack_public_path__ + "static/media/package_support_20.0e25c5e9.svg";